module.exports = "<canvas #canvas id=\"canvas\"></canvas>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/canvas-grid/canvas-grid.component.html
// module id = ./src/app/shared/canvas-grid/canvas-grid.component.html
// module chunks = main